import { FC } from "react";
import { Styled } from "./styled";
import useWord, { IProps } from "./hook";

const WordLayout = (props: ReturnType<typeof useWord>) => {
  const { uri, containerRef } = props;

  return (
    <Styled>
      <div
        style={{
          width: "100%",
          height: "calc(100% - 40px)",
          overflow: "auto",
          padding: 10,
          background: "gray",
        }}
      >
        <div ref={containerRef}></div>
      </div>
    </Styled>
  );
};

const Word: FC<IProps> = (props: IProps) => <WordLayout {...useWord(props)} />;

export default Word;
